import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/tipos-de-conceptos-de-infracciones/';

/**
 * GET Tipo de Concepto de Infracciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getTipoDeConceptoDeInfracciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Concepto de Infracción
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeConceptoDeInfraccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Concepto de Infraccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeConceptoDeInfraccion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Concepto de Infraccion
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeConceptoDeInfraccion = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Tipo de Concepto de Infraccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeConceptoDeInfraccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
